import { Injectable } from '@angular/core'

export interface ErrorObject {
  [key: string]: string | string[] | undefined
}

@Injectable({
  providedIn: 'root',
})
export class GbErrorMessageService {
  /**
   * Gets first error message from error object
   * @param errorObj: ErrorObject | string[] | undefined
   * @returns the first error value string from the provided ErrorObject object
   */

  getFirstErrorMessage(error: ErrorObject | string[] | undefined): string | undefined {
    if (Array.isArray(error)) return error[0]

    let errorMessage = ''
    const errorMessageList: string[] | string | undefined = error && error[Object.keys(error)[0] as keyof ErrorObject]

    if (errorMessageList) {
      errorMessage = Array.isArray(errorMessageList) ? errorMessageList[0] : errorMessageList
    }

    return errorMessage
  }

  /**
   * Retrieves a specific error message from the ErrorObject object or a generic error message
   * @param error: ErrorObject | undefined | string[] - the ErrorObject object from which to extract the error message
   * @returns a specific error message if available and not an HTML response; otherwise, returns a generic error message
   */

  getErrorMessage(error: ErrorObject | undefined | string[]): string | undefined {
    const firstErrorMessage = this.getFirstErrorMessage(error)

    if (firstErrorMessage !== '<') {
      return firstErrorMessage
    }

    return 'GENERIC.ERROR'
  }
}
